import React, { useContext, useState, useEffect } from 'react'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import AppointmentContext from '@/product/context/appointment/appointmentContext'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import { useFormik } from 'formik'
import { Button } from '@mui/material'
import AppointmentManage from './AppointmentManage'
import { handleRedirectInternal } from '@/custom/common/components'
import { useHistory } from 'react-router-dom'

const Appointment = (props) => {
    const appointmentContext = useContext(AppointmentContext)
    const [isLoading, setIsLoading] = useState(true)
    const history = useHistory()
    const {
        all_appointments,
        getAllAppointments,
        responseStatus: responseStatusAppointment,
        clearResponse: clearResponseAppointment,
    } = appointmentContext

    let action = props.match.params.action
    const [tableBody, setTableBody] = useState([])

    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
        user_type: 0,
    })
    const [state, setState] = useState({
        right: false,
    })
    const toggleDrawer = (open, id) => {
        setManage({ popup: 'Comment', status: '', id })

        setState({
            right: open,
        })
    }
    const toggleFullScreenPopup = (popup, status, id, user_type) => {
        if (popup) {
            setManage({ popup, status, id, user_type })
        } else {
            getAllAppointments(formik.values)
            setManage({ popup, status: 'new', id: 0, user_type: 0 })
        }
    }

    const onClickEdit = (id, secId, type) => {
        if (type === 'Comment') {
            toggleDrawer(true, id)
        } else {
            toggleFullScreenPopup(true, 'edit', id)
        }
    }

    const formik = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: 'desc',
            orderby: 'a.id',
            filters: {
                valid: {
                    field: 'a.status',
                    type: 'notin',
                    value: 'open',
                },
                invoice: {
                    field: 'b.common_invoice',
                    type: 'in',
                    value: '',
                },
                auction: {
                    field: 'ac.title',
                    type: 'like',
                    value: '',
                },
                first_name: {
                    field: 'u.first_name',
                    type: 'like',
                    value: '',
                },
                last_name: {
                    field: 'u.last_name',
                    type: 'like',
                    value: '',
                },
                fromdate: {
                    value: '',
                    type: 'dategreaterequal',
                    field: 'a.appointmentTime',
                },
                todate: {
                    value: '',
                    type: 'datesmallerequal',
                    field: 'a.appointmentTime',
                },
            },
        },
        onSubmit: (values) => {
            setIsLoading(true)
            getAllAppointments(values)
        },
    })

    const resetForm = () => {
        formik.values.filters.invoice.value = ''
        formik.values.filters.auction.value = ''
        formik.values.filters.first_name.value = ''
        formik.values.filters.last_name.value = ''
        formik.values.filters.fromdate.value = ''
        formik.values.filters.todate.value = ''

        getAllAppointments(formik.values)
    }

    useEffect(() => {
        if (all_appointments) {
            setTableBody(
                all_appointments.records.length
                    ? all_appointments.records.map((apt) => {
                          apt.status =
                              apt.status === 'booked'
                                  ? 'unfulfilled'
                                  : apt.status
                          return apt
                      })
                    : []
            )
        }
        setIsLoading(false)
    }, [all_appointments])

    const onClickInvoiceEdit = (id, secondaryID, type) => {
        handleRedirectInternal(history, `invoice/view/${id}/${secondaryID}`)
    }

    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        formik.values.page = 1

        getAllAppointments(formik.values)
        return () => {
            setTableBody([])
        }
    }, [action])

    useEffect(() => {
        if (responseStatusAppointment) {
            if (responseStatusAppointment.from === 'appointment') {
                formik.setSubmitting(false)
                setIsLoading(false)
            }
        }
    }, [responseStatusAppointment])

    const getMultipleAction = () => {
        let actionPush = []
        if (!(action === 'closed')) {
            actionPush.push({
                field: 'action',
                type: 'button',
                clickType: 'edit',
                onclick: onClickEdit,
                sort: false,
                firstChild: false,
                disablePadding: false,
                label: 'Action',
                tooltipTitle: 'Edit Appointment',
            })
        }
        return actionPush
    }
    const tableValues = [
        {
            field: 'id',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Id',
            filterable: true,
            filterField: 'a.id',
        },
        {
            field: 'common_invoice',
            type: 'hyperlink',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Invoice ID',
            click: true,
            onclick: onClickInvoiceEdit,
            clickID: 'common_invoice',
            secondaryClickID: 'userId',
            clickType: 'edit',
            filterField: 'b.common_invoice',
        },
        {
            field: 'first_name,last_name',
            type: '',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: 'Customer',
            filterable: true,
            filterField: 'u.first_name,u.last_name',
        },
        {
            field: 'project_title',
            type: 'capitalize',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Lot',
            filterable: true,
            filterField: 'p.title',
        },
        {
            field: 'auction_title',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Auction',
            filterable: true,
            filterField: 'ac.title',
        },
        {
            field: 'appointmentTime',
            type: 'datetime',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Appointment Date',
        },
        {
            field: 'status',
            type: 'capitalize',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Status',
        },
        {
            field: 'notes',
            type: 'capitalize',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Notes',
            filterable: true,
            filterField: 'a.notes',
        },
        {
            field: 'action',
            type: 'button',
            isMultiple: true,
            clickID: 'id',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            isMultiple: getMultipleAction(),
        },
    ]

    const searchInfo = {
        formik: formik,
        data: [
            {
                label: 'Invoice ID',
                placeholder: 'Enter Invoice ID',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'invoice',
                filter: true,
            },
            {
                label: 'Auction Name',
                placeholder: 'Enter Auction name',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'auction',
                filter: true,
            },
            {
                label: 'First Name',
                placeholder: 'Enter First Name',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'first_name',
                filter: true,
            },
            {
                label: 'Last Name',
                placeholder: 'Enter Last Name',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'last_name',
                filter: true,
            },

            {
                label: 'From Date',
                placeholder: 'Date Ending From',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'date',
                name: 'fromdate',
                filter: true,
            },
            {
                label: 'To Date',
                placeholder: 'Date Ending To',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'date',
                name: 'todate',
                filter: true,
            },
        ],
    }

    const tableActions = []

    return (
        <Layout>
            <div className="dashboard invoice">
                <CustomSearch
                    searchInfo={searchInfo}
                    formik={formik}
                    advFilters={true}
                    resetForm={resetForm}
                />
                {/* <div className="text-left">
                    <Button
                        onClick={() =>
                            getAllExportDownload({
                                fields: [
                                    'common_invoice',
                                    'trans_id',
                                    'amount',
                                    'user_fullname',
                                    'email',
                                    'payment_method',
                                    'card_type',
                                    'created_at',
                                ],
                                action: 'export',
                                order: 'asc',
                                orderby: '',
                                search: 'all',
                                report: `transaction_list`,
                                filters: {},
                            })
                        }
                    >
                        <span className="material-icons">get_app</span>Export All Data
                    </Button>
                </div> */}
                <CustomTable
                    formik={formik.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={tableActions}
                    allData={all_appointments}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    changeTableFunction={getAllAppointments}
                />
                <AppointmentManage
                    data={manage}
                    function={toggleFullScreenPopup}
                />
            </div>
        </Layout>
    )
}

export default Appointment
